import { render, staticRenderFns } from "./MyApprovalsMyResponses.vue?vue&type=template&id=3feb70a8"
import script from "./MyApprovalsMyResponses.vue?vue&type=script&lang=js"
export * from "./MyApprovalsMyResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports